import { useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import Form from 'react-bootstrap/Form';
import { InfoTooltip } from '../../../components/InfoTooltip';

export default function ExamInfo(props) {

    const t = useSelector(selectTranslations)

    const handleDataChange = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        props.onExamDataChange({
            ...props.examData,
            [name]: value
        })
    }

    const handleStateChange = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        props.onExamDataChange({
            ...props.examData,
            state: value ? 'ready' : 'draft'
        })
    }

    return(
        <>
            <div className="info_card exams-step-3">
                <h2>{t.exam.primary_info}</h2>
                <Form.Check // prettier-ignore
                    type="switch"
                    name='ready'
                    checked={props?.examData?.state === "ready"}
                    onChange={handleStateChange}
                    id="custom-switch"
                    label={t.exam.is_ready}
                />
                <Form.Group controlId="title">
                    <Form.Label>{t.exam.title}*</Form.Label>
                    <Form.Control type="text" value={props.examData.title || ''} name="title" placeholder={t.exam.title} required onChange={handleDataChange} />
                </Form.Group>
                <Form.Group controlId="description" className='mt-2'>
                    <Form.Label>{t.exam.description}*</Form.Label>
                    <Form.Control type="text" as="textarea" value={props.examData.description || ''} name="description" placeholder={t.exam.description} onChange={handleDataChange} />
                </Form.Group>
                <Form.Group controlId="disclaimer" className='mt-2'>
                    <Form.Label>{t.exam.disclaimer}</Form.Label>
                    <Form.Control type="text" className='border border-warning' as="textarea" value={props.examData.preview_disclaimer || ''} name="preview_disclaimer" placeholder={t.exam.disclaimer} onChange={handleDataChange} />
                </Form.Group>
                <div className='d-flex justify-content-between mt-2'>
                    <Form.Group controlId="start_date" className='col-6'>
                        <Form.Label>{t.exam.start_date}</Form.Label>
                        <Form.Control className='minw-0' type="date" name="start_date" value={props.examData.start_date ? new Date(props.examData.start_date).toISOString().substring(0,10) : ''} onChange={handleDataChange} />
                    </Form.Group>
                    <Form.Group controlId="end_date" className='col-6 ps-2'>
                        <Form.Label>{t.exam.end_date}</Form.Label>
                        <Form.Control className='minw-0' type="date" name="end_date" value={props.examData.end_date ? new Date(props.examData.end_date).toISOString().substring(0,10) : ''} onChange={handleDataChange}  />
                    </Form.Group>
                </div>
            </div>
            <div className="info_card mt-3">
                <h2>{t.exam.secondary_info}</h2>
                <div className='row'>
                    <div className='col-6'>
                        <div className='d-flex'>
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="is_multiple_attempts"
                                name="is_multiple_attempts"
                                label={t.exam.is_multiple_attempts}
                                onChange={handleDataChange}
                                checked={props.examData?.is_multiple_attempts}
                            />
                            <InfoTooltip className="ms-2" content={<p>L'utente potrà ripetere la prova più volte nella finestra di disponibilità</p>} />
                        </div>
                        <div className='d-flex mt-2'>
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="questions_review"
                                name="visible_questions_review"
                                label={t.exam.questions_review}
                                onChange={handleDataChange}
                                checked={props.examData?.visible_questions_review}
                            />
                            <InfoTooltip className="ms-2" content={<p>“Rivedi domande” permette agli utenti di rivedere le domande della verifica una volta terminata.</p>} />
                        </div>
                        <div className='d-flex mt-2'>
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="visible_scoreboard"
                                name="visible_scoreboard"
                                label={t.exam.visible_scoreboard}
                                onChange={handleDataChange}
                                checked={props.examData?.visible_scoreboard}
                            />
                            <InfoTooltip className="ms-2" content={<p>“Classifica visibile” permette agli utenti di vedere una classifica con i punteggi di tutti gli utenti.</p>} />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className='d-flex'>
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="scramble_questions"
                                name="scramble_questions"
                                label={t.exam.scramble_questions}
                                onChange={handleDataChange}
                                checked={props.examData?.scramble_questions}
                            />
                        </div>
                        <div className='d-flex mt-2'>
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="scramble_answers"
                                name="scramble_answers"
                                label={t.exam.scramble_answers}
                                onChange={handleDataChange}
                                checked={props.examData?.scramble_answers}
                            />
                        </div>
                    </div>
                </div>
                <hr />
                <div className='row'>
                    <div className='col-6'>
                        <div className='d-flex'>
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="is_not_resumable"
                                name="is_not_resumable"
                                label={t.exam.is_not_resumable}
                                onChange={handleDataChange}
                                checked={props.examData?.is_not_resumable}
                            />
                            <InfoTooltip className="ms-2" content={<p>L'utente non potrà mettere in background la prova e riprenderla</p>} />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className='d-flex'>
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="auto_close_user_exam"
                                name="auto_close_user_exam"
                                label={t.exam.auto_close_user_exam}
                                onChange={handleDataChange}
                                checked={props.examData?.auto_close_user_exam}
                            />
                            <InfoTooltip className="ms-2" content={<p>La prova verrà automaticamente chiusa allo scadere del tempo</p>} />

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}